import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "creditor-access-banner",
  "aria-label": "Creditor portal access"
}
const _hoisted_2 = { class: "creditor-access-banner__message" }


export default /*@__PURE__*/_defineComponent({
  __name: 'CreditorAccessBanner',
  props: {
    creditorName: {}
  },
  emits: ["exit"],
  setup(__props: any) {

/* eslint-env vue/setup-compiler-macros */




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _cache[1] || (_cache[1] = _createTextVNode(" You are currently logged in to ", -1)),
      _createElementVNode("strong", null, _toDisplayString(__props.creditorName) + "’s portal", 1)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "creditor-access-banner__exit",
      "aria-label": "Exit creditor portal access",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('exit')))
    }, " Exit Access ")
  ]))
}
}

})